<div class="container" style="padding: 0">
  <div class="floating-buttons">
    <a href="javascript:void(0)" (keyup.enter)="scrollTop()" (click)="scrollTop()" style="cursor: pointer">
      <img
        [attr.alt]="'GAST-PORTAL-NG.FLOATING-BUTTONS.SCROLL-TOP' | translate"
        class="floating-icon"
        src="portal-assets/img/arrow_42px.png" />
    </a>
    @for (link of floatingButtonsModel().floatingButtons; track link.linkUrl) {
      <a href="{{ link.linkUrl }}" target="_blank">
        <img [attr.alt]="link.iconUrl" class="floating-icon" [attr.src]="link.iconUrl" />
      </a>
    }
  </div>
</div>
